// extracted by mini-css-extract-plugin
export default {"wrap":"TabPanel_wrap_bOdfe","header":"TabPanel_header_OFuPi","title":"TabPanel_title_WkIeh","subtitle":"TabPanel_subtitle__4RkI","content":"TabPanel_content_T0U25"};